import { useState } from "react";
import { Loader2, ShoppingCart } from "lucide-react";
import { startCheckout, PRICE_LABEL } from "@/lib/checkout";

export const BuyButton = ({ testId, label, className = "", showPrice = false }) => {
    const [loading, setLoading] = useState(false);
    const onClick = async () => {
        setLoading(true);
        try {
            await startCheckout();
        } finally {
            setLoading(false);
        }
    };
    return (
        <button
            data-testid={testId}
            onClick={onClick}
            disabled={loading}
            className={`group relative inline-flex items-center justify-center gap-2.5 rounded-lg bg-gold px-7 py-4 font-bold text-navy-950 transition-[background-color,transform,box-shadow] duration-300 hover:bg-gold-hover hover:-translate-y-0.5 hover:shadow-[0_12px_36px_rgba(240,180,41,0.4)] active:translate-y-0 disabled:opacity-70 ${className}`}
        >
            {loading ? (
                <Loader2 className="h-5 w-5 animate-spin" />
            ) : (
                <>
                    <ShoppingCart className="h-5 w-5 shrink-0" />
                    <span className="whitespace-nowrap text-base">{label}</span>
                    {showPrice && <span className="font-metric font-bold">{PRICE_LABEL}</span>}
                </>
            )}
        </button>
    );
};
